import { render, staticRenderFns } from "./allPallet.vue?vue&type=template&id=75ba6afe&"
import script from "./allPallet.vue?vue&type=script&lang=js&"
export * from "./allPallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports